<template>
  <div class="flex-1 flex-grow mt-6">
    <div class="flex flex-col max-w-xl mx-auto">
      <div class="flex flex-col justify-center px-6 space-y-4">
        
        <!-- Address -->
        <template v-if="form.destinations.length < 1 || showForm">
          <BookHelpBubble 
            v-if="options.destination_help_text" 
            :content="options.destination_help_text" />
          <BookAddressForm
            ref="addressForm"
            address-type="destinations" />
        </template>

        <!-- Start -->
        <template v-else>
          <div class="p-6 text-center bg-gray-100 rounded-md">
            <div class="text-center text-gray-500">
              You have {{ form.destinations.length }} {{ form.destinations.length | pluralize(['delivery', 'deliveries']) }} already.
            </div>
            <button class="mt-4 text-sm btn btn-secondary" @click="showForm = true" v-if="form.destinations.length > 0 && options.allow_multiple_destinations">
              <fa :icon="['far', 'plus']" class="mr-2" /> Add Another Delivery
            </button>
          </div>
        </template>

      </div>
    </div>

    <!-- Bottom Bar -->
    <BookBottomBar>
      <template slot="back">
        <button 
          v-if="form.destinations.length >= 1 && showForm" 
          class="w-full font-medium text-red-500 btn btn-outline" 
          @click="showForm = false">
          <fa :icon="['far', 'times']" class="mr-2 text-sm" /> Cancel
        </button>
        <button 
          v-else 
          class="w-full btn btn-outline" 
          @click="$parent.back()">
          <fa :icon="['far', 'chevron-left']" class="mr-2 text-sm" /> Back
        </button>
      </template>

      <template slot="next">
        <button 
          v-if="showForm" 
          class="w-full btn btn-accent" 
          @click="saveAndAdd()">
          Save &amp; Add <fa :icon="['far', 'chevron-right']" class="ml-2 text-sm" />
        </button>
        <button 
          v-else 
          class="w-full btn btn-accent" 
          @click="$parent.next()">
          Next <fa :icon="['far', 'chevron-right']" class="ml-2 text-sm" />
        </button>
      </template>
    </BookBottomBar>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import BookAddressForm from './BookAddressForm'
import BookBottomBar from './BookBottomBar'
import BookHelpBubble from './BookHelpBubble'

export default {
  name: 'BookDestination',

  components: {
    BookAddressForm,
    BookBottomBar,
    BookHelpBubble
  },

  created () {
    if (this.form.destinations.length > 0) {
      this.showForm = false
    }
  },

  computed: {
    ...mapState('booking', ['form', 'options'])
  },
  
  data () {
    return {
      showForm: true,
      address: null
    }
  },

  methods: {
    back () {
      this.showForm = true
    },

    saveAndAdd () {
      if (this.$refs.addressForm.submit()) {
        this.showForm = false
      }
    }
  }
}
</script>